import { ОСЕТРОВЫЕ } from './species/acipenserids.js';
import { ЦЕНТРАРХОВЫЕ } from './species/centrarchids.js';
import { ЗМЕЕГОЛОВЫЕ } from './species/channids.js';
import { ХАРАЦИНОВЫЕ } from './species/characids.js';
import { ЦИХЛОВЫЕ } from './species/cichlids.js';
import { СЕЛЬДЕВЫЕ } from './species/clupeids.js';
import { ВЬЮНОВЫЕ } from './species/cobitids.js';
import { СИГОВЫЕ } from './species/coregonids.js';
import { КАРПОВЫЕ } from './species/cyprinids.js';
import { ЩУКОВЫЕ } from './species/esocids.js';
import { БЫЧКОВЫЕ } from './species/gobiids.js';
import { ПАНЦИРНИКОВЫЕ } from './species/lepisosteids.js';
import { ПРОЧИЕ } from './species/misc.js';
import { КОРЮШКОВЫЕ } from './species/osmerids.js';
import { ОКУНЁВЫЕ } from './species/percids.js';
import { МИНОГОВЫЕ } from './species/petromyzontids.js';
import { ЛОСОСЁВЫЕ } from './species/salmonids.js';
import { СОМОВЫЕ } from './species/siluriforms.js';
import { АУХОВЫЕ } from './species/sinipercids.js';
/**
 * Виды рыбы, объявленные в энциклопедии, но ещё не играющие.
 *
 * ⚠️ ЭТОТ ФАЙЛ НЕ ХРАНИТ ДАННЫЕ, А ТОЛЬКО СОБИРАЕТ ИХ. Сами виды лежат в
 * `species/` — по файлу на семейство.
 *
 * ⚠️ ДЕЛЕНИЕ ПО СЕМЕЙСТВАМ, А НЕ ПО ЧАСТЯМ СВЕТА, И ЭТО ПЕРЕМЕНА РЕШЕНИЯ.
 * Прежде виды лежали двумя сотнями — «наша полоса» и «остальной мир», — и
 * довод был такой: одних карповых семьдесят, файл сразу подойдёт к пределу.
 * Довод оказался неверным по счёту: семьдесят записей — это 25 КБ, а с рядом
 * «чем берётся» станет 36 КБ при пределе в 100.
 *
 * А вот довод против частей света оказался верным по делу. Заполнять «чем
 * берётся» приходится семействами: у карповых своё — червь, кукуруза, бойл, у
 * лососёвых своё — мушка, икра, блесна. При делении по частям света карповые
 * лежали в двух файлах вперемешку с лососёвыми, и одна работа растекалась по
 * двум местам, а в каждом месте перемешивалась с чужой.
 *
 * ⚠️ СПИСОК ФАЙЛОВ ВЕДЁТСЯ РУКАМИ, И ЗА НИМ СЛЕДИТ ТЕСТ. Забыть новый файл
 * здесь — значит потерять целое семейство молча: справочник соберётся, тесты
 * прежних видов пройдут, а рыбы в игре не будет. Поэтому `test/species.test.ts`
 * читает папку и сверяет её с этим списком.
 *
 * ⚠️ ПОРЯДОК ВНУТРИ ВАЖЕН ТОЛЬКО ДЛЯ ЧЕЛОВЕКА. Энциклопедия сама раскладывает
 * список по семействам и сортирует по алфавиту текущего языка — от порядка в
 * массиве на экране не зависит ничего.
 */
export const ПО_СЕМЕЙСТВАМ = {
    карповые: КАРПОВЫЕ,
    лососёвые: ЛОСОСЁВЫЕ,
    сомовые: СОМОВЫЕ,
    сиговые: СИГОВЫЕ,
    окунёвые: ОКУНЁВЫЕ,
    прочие: ПРОЧИЕ,
    осетровые: ОСЕТРОВЫЕ,
    щуковые: ЩУКОВЫЕ,
    центрарховые: ЦЕНТРАРХОВЫЕ,
    харациновые: ХАРАЦИНОВЫЕ,
    корюшковые: КОРЮШКОВЫЕ,
    бычковые: БЫЧКОВЫЕ,
    вьюновые: ВЬЮНОВЫЕ,
    миноговые: МИНОГОВЫЕ,
    змееголовые: ЗМЕЕГОЛОВЫЕ,
    цихловые: ЦИХЛОВЫЕ,
    сельдевые: СЕЛЬДЕВЫЕ,
    ауховые: АУХОВЫЕ,
    панцирниковые: ПАНЦИРНИКОВЫЕ,
};
/**
 * Имена файлов в `species/` — по одному на семейство.
 *
 * ⚠️ ЛЕЖИТ ЗДЕСЬ, А НЕ В ТЕСТЕ, ХОТЬ ЧИТАЕТ ЕГО ТОЛЬКО ТЕСТ. Заведи мы этот
 * список в тесте — он стал бы третьим местом, где перечислены семейства, и
 * разошёлся бы с ввозами выше при первом же добавлении. Здесь он стоит рядом с
 * ними, и забыть строку, дописывая соседнюю, заметно глазами.
 */
export const ФАЙЛЫ_СЕМЕЙСТВ = {
    карповые: 'cyprinids',
    лососёвые: 'salmonids',
    сомовые: 'siluriforms',
    сиговые: 'coregonids',
    окунёвые: 'percids',
    прочие: 'misc',
    осетровые: 'acipenserids',
    щуковые: 'esocids',
    центрарховые: 'centrarchids',
    харациновые: 'characids',
    корюшковые: 'osmerids',
    бычковые: 'gobiids',
    вьюновые: 'cobitids',
    миноговые: 'petromyzontids',
    змееголовые: 'channids',
    цихловые: 'cichlids',
    сельдевые: 'clupeids',
    ауховые: 'sinipercids',
    панцирниковые: 'lepisosteids',
};
export const ПЛАНИРУЕМЫЕ = Object.values(ПО_СЕМЕЙСТВАМ).flat();
//# sourceMappingURL=species-planned.js.map